import React from 'react';
import classNames from 'classnames';
import { Modal } from 'react-responsive-modal';
import ButtonWithSpinner from 'components/buttons/ButtonSpinner';
import valUtils from "utils/validations"
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import useAccount from 'hooks/useAccount';

const PasswordUpdate = (props) => {
    const { updatePassword } = useAccount();
    const validationSchema = Yup.object().shape({
        password: valUtils.password(),
        confirmPassword: valUtils.confirmPassword("password"),
    });

    const { open, close } = props;

    const {
        handleSubmit,
        formState: { errors },
        register,
    } = useForm({
        mode: 'all',
        defaultValues: {
            password: '',
            confirmPassword: ''
        },
        resolver: yupResolver(validationSchema)
    });

    const onSubmitHandler = async (frmData, e) => {
        e.preventDefault();
        if (updatePassword.isLoading) return;

        updatePassword.mutateAsync({ Password: frmData.password })
            .then(() => close())
            .catch(() => {}); // error handled by onError in useAccount
    };

    return (
        <Modal classNames={{ overlay: 'verification-overlay', modal: 'verification-modal' }}
            open={open}
            onClose={close}
            center>
            <h2>Password Update</h2>

            <form className="verification-form" onSubmit={handleSubmit(onSubmitHandler)}>
                <fieldset className="input">
                    <p className={classNames("create-pass", { error: errors?.password?.message })}>
                        <label htmlFor="create-pass">Create your password</label>
                        <input id="create-pass" autoComplete="new-password" type="password" placeholder="New password" {...register("password")} />
                        <span className="error-msg">{errors?.password?.message}</span>
                    </p>
                    <p className={classNames("confirm-pass", { error: errors?.confirmPassword?.message })}>
                        <label htmlFor="confirm-pass">Confirm password</label>
                        <input id="confirm-pass" autoComplete="new-password" type="password" placeholder="Confirm password" {...register("confirmPassword")} />
                        <span className="error-msg">{errors?.confirmPassword?.message}</span>
                    </p>
                </fieldset>
                <fieldset className="submit">
                    <p className="btn grey">
                        <ButtonWithSpinner text={`Update`} isLoading={updatePassword.isLoading} />
                    </p>
                </fieldset>
            </form>
        </Modal>
    );
};

export default PasswordUpdate;
